// extracted by mini-css-extract-plugin
module.exports = {"mainWidth":"1200px","navHeight":"72px","theme":"#5183DB"};